<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						
					</div>
					<div class="card-body overflow-auto">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<label>From Year</label>
										<input type="number" class="form-control" placeholder="From Year" v-model="fromyear">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>From Month</label>
										<select class="form-control" v-model="frommonth">
											<option value="1">January</option>
											<option value="2">February</option>
											<option value="3">March</option>
											<option value="4">April</option>
											<option value="5">May</option>
											<option value="6">June</option>
											<option value="7">July</option>
											<option value="8">August</option>
											<option value="9">September</option>
											<option value="10">October</option>
											<option value="11">November</option>
											<option value="12">December</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>To Year</label>
										<input type="number" class="form-control" placeholder="To Year" v-model="toyear">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>To Month</label>
										<select class="form-control" v-model="tomonth">
											<option value="1">January</option>
											<option value="2">February</option>
											<option value="3">March</option>
											<option value="4">April</option>
											<option value="5">May</option>
											<option value="6">June</option>
											<option value="7">July</option>
											<option value="8">August</option>
											<option value="9">September</option>
											<option value="10">October</option>
											<option value="11">November</option>
											<option value="12">December</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<button class="btn btn-primary" @click="getStats">Generate</button>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-12" v-if="receipts.length == 0 && saleorders.length == 0 && invoices.length == 0">
							<h1>No data. Fill in required fields and click genereate.</h1>
						</div>
					</div>
					<div class="card-footer">
						
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	//this.getStats();
        },
        
        data(){
        	return{
		      	receipts: [],
		      	saleorders: [],
		      	invoices: [],
		      	receipttotal: '',
		      	saleordertotal: '',
		      	invoicetotal: '',
		      	fromyear: '',
		      	frommonth: '',
		      	toyear: '',
		      	tomonth: ''
		      }
        },
        
        methods: {
        	getStats(){
        		axios.post("/api/monthlyReceiptAudit", {fromyear: this.fromyear, frommonth: this.frommonth, toyear: this.toyear, tomonth: this.tomonth})
        		.then(response => {
        			this.receipts = response.data.branches;
        			this.receipttotal = response.data.total;
        		});
        		
        		axios.post("/api/monthlySaleOrderAudit", {fromyear: this.fromyear, frommonth: this.frommonth, toyear: this.toyear, tomonth: this.tomonth})
        		.then(response => {
        			this.saleorders = response.data.branches;
        			this.saleordertotal = response.data.total;
        		});
        		
        		axios.post("/api/monthlyInvoiceAudit", {fromyear: this.fromyear, frommonth: this.frommonth, toyear: this.toyear, tomonth: this.tomonth})
        		.then(response => {
        			this.invoices = response.data.branches;
        			this.invoicetotal = response.data.total;
        		});
        	}
        }
    }
</script>
